import {
    DOCUMENT_HEAD_TITLE_SET,
} from 'state/action-types';


/**
 * [setDocumentHeadTitle description]
 * 
 * @param {[type]} title [description]
 */
export function setDocumentHeadTitle( title ) {
    return {
        type: DOCUMENT_HEAD_TITLE_SET,
        title,
    };
}
